import React, { useEffect, useRef } from 'react'

// UTILS
import { thousandSeparator } from '../../utils/helpers'
import { useCallback } from 'react'

const AllGroup = (props) => {
    const selectedBranch = props.selectedBranch
    const groupRef = useRef(null)
    const isDownRef = useRef(false)
    const startXRef = useRef(0)
    const scrollLeftRef = useRef(0)

    const handleClick = (group) => {
        props?.selectGroup(group)
    }

    const handleMouseDown = useCallback((e) => {
        e.preventDefault()
        isDownRef.current = true
        startXRef.current = e.pageX - groupRef.current.offsetLeft
        scrollLeftRef.current = groupRef.current.scrollLeft
    }, [])

    const handleMouseLeave = useCallback(() => {
        isDownRef.current = false
    }, [])

    const handleMouseUp = useCallback(() => {
        isDownRef.current = false
    }, [])

    const handleMouseMove = useCallback((e) => {
        e.preventDefault()
        if (!isDownRef.current) return
        const x = e.pageX - groupRef.current.offsetLeft
        const walk = (x - startXRef.current) * 1
        groupRef.current.scrollLeft = scrollLeftRef.current - walk
    }, [])

    useEffect(() => {
        const slider = groupRef.current

        if (slider) {
            slider.scrollTo({
                left: 0,
                behavior: "smooth",
            }) 
        }

        if (selectedBranch && slider) {
            slider.addEventListener('mousedown', handleMouseDown)
            slider.addEventListener('mouseleave', handleMouseLeave)
            slider.addEventListener('mouseup', handleMouseUp)
            slider.addEventListener('mousemove', handleMouseMove)
        }

        return () => {
            if (slider) {
                slider.removeEventListener('mousedown', handleMouseDown)
                slider.removeEventListener('mouseleave', handleMouseLeave)
                slider.removeEventListener('mouseup', handleMouseUp)
                slider.removeEventListener('mousemove', handleMouseMove)
            }
        }
    }, [selectedBranch])

    return (
        <>
            {
                selectedBranch.group?.length > 0 &&
                <>
                    <div className='-my-4'>
                        <div ref={ groupRef } className='relative overflow-scroll hide-scrollbar flex md:gap-4 gap-2 py-4'>
                            {
                                selectedBranch.group.map((item, idx) => {
                                    return <div key={ 'group_'+idx } onClick={ () => handleClick(item.group) } className='rounded-[10px] bg-white shadow-md py-2 px-4 md:w-1/4 w-[90%] flex-shrink-0 relative block cursor-pointer transition transform hover:scale-[1.01]'>
                                        <p className='text-xs font-semibold text-gray-two'>{ item.group }</p>
                                        <div className='flex items-center justify-between'>
                                            <p className='md:text-xl text-lg font-bold text-gray-one'>RM { thousandSeparator(item.totalCommission) }</p>
                                            {/* <div className='border-8 border-orange rounded-full h-10 w-10 relative'>
                                                <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 border-8 border-transparent border-l-primary w-10 h-10 rounded-full rotate-[45deg]'></div>
                                            </div> */}
                                        </div>
                            
                                        <div className='flex items-center gap-4'>
                                            <div className='flex items-center gap-1.5'>
                                                <span className='flex-shrink-0 h-2 w-2 rounded-full bg-primary'></span>
                                                <p className='md:text-sm text-xs text-gray-two'>RM { thousandSeparator(item.subsale) }</p>
                                            </div>

                                            <div className='flex items-center gap-1.5'>
                                                <span className='flex-shrink-0 h-2 w-2 rounded-full bg-orange'></span>
                                                <p className='md:text-sm text-xs text-gray-two'>RM { thousandSeparator(item.project) }</p>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </>
            }
        </>
    )
}

export default AllGroup